var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-background_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3F4F8",
  d: "M18.204 0H5.796A5.796 5.796 0 0 0 0 5.796v12.408A5.796 5.796 0 0 0 5.796 24h12.408A5.796 5.796 0 0 0 24 18.204V5.796A5.796 5.796 0 0 0 18.204 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.764 9.84a1.536 1.536 0 1 0 0-3.072 1.536 1.536 0 0 0 0 3.072"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.24 17.532 3.444-3.444a3.396 3.396 0 0 1 4.428-.312l2.856 2.136 2.436-3.48a3.4 3.4 0 0 1 2.328-1.416 3.44 3.44 0 0 1 2.616.756l5.328 4.44.336.3V5.844A5.85 5.85 0 0 0 18.168 0H5.844C2.628 0 0 2.628 0 5.844v11.952zM10.764 4.92a3.39 3.39 0 0 1 3.384 3.384 3.396 3.396 0 0 1-3.384 3.384A3.396 3.396 0 0 1 7.38 8.304a3.396 3.396 0 0 1 3.384-3.384"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.312 22.561 3.6-5.136-2.904-2.184a1.55 1.55 0 0 0-2.016.144l-3.408 3.408-1.212 1.308a5.83 5.83 0 0 0 5.016 3.84l.924-1.392zM22.464 17.604l-5.304-4.416a1.58 1.58 0 0 0-1.188-.348c-.432.06-.804.288-1.056.648l-7.08 10.116-.264.396h10.584c2.964 0 5.388-2.22 5.772-5.076z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-background_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgIcBackground;